import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import {
  Row,
  SkeletonLoader,
  ButtonIconContextual
} from '@warrenbrasil/nebraska-web';
import { PercentualText } from '@/modules/common/components/PercentualText';
import { TooltipModal } from '@/modules/common/components/TooltipModal';

import { GetInstrumentPositionHistoricalResponse } from '@/modules/trade/services/instruments';
import { tooltipModalData } from './data';
import { TooltipModalTypes } from './types';

interface Props {
  position: GetInstrumentPositionHistoricalResponse;
  isLoading: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HistoricalPosition',
  props: {
    position: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  position: GetInstrumentPositionHistoricalResponse;
  isLoading: boolean;
};



const isTooltipModalOpen = ref(false);
const selectedTooltipType = ref(TooltipModalTypes.ProfitAmount);

const paidEventsFormatted = computed(
  () => props.position.paidEvents?.formatted || '-'
);

const tooltipData = computed(() => {
  return tooltipModalData[selectedTooltipType.value];
});

const openTooltipModal = (type: TooltipModalTypes) => {
  selectedTooltipType.value = type;
  isTooltipModalOpen.value = true;
};

const closeTooltipModal = () => {
  isTooltipModalOpen.value = false;
};

return { __sfc: true,props, isTooltipModalOpen, selectedTooltipType, paidEventsFormatted, tooltipData, openTooltipModal, closeTooltipModal, Row, SkeletonLoader, ButtonIconContextual, PercentualText, TooltipModal, TooltipModalTypes }
}

})